import React from 'react';
import { Helmet } from "react-helmet";
import TermsConditions from '../Components/TermsConditions';

const Terms = () => {
  return (
    <>
      <Helmet>
        <title>Terms & Conditions | Vangal Farms</title>
        <meta
          name="description"
          content="Read the Terms & Conditions of Vangal Farms. Learn about policies, user responsibilities, limitations, and usage guidelines for our dairy products and services."
        />
      </Helmet>

      <TermsConditions />
    </>
  );
};

export default Terms;
